import { render, staticRenderFns } from "./NotificationPopover.vue?vue&type=template&id=a9773fdc&scoped=true&"
import script from "./NotificationPopover.vue?vue&type=script&lang=js&"
export * from "./NotificationPopover.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPopover.vue?vue&type=style&index=0&id=a9773fdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9773fdc",
  null
  
)

export default component.exports